import ar from '@/locale/ar'
import fr from '@/locale/fr'
import { createI18n } from 'vue-i18n'


const i18n = createI18n({
  legacy: false, 
  locale: 'fr', 
  fallbackLocale: 'fr',
  messages: { ar, fr }
})

export default i18n
